module.exports = __webpack_public_path__ + "img/26.55d8071e.jpg";